export const pedagogyConst = {
  path: "/single-programs/pedagogy",
  title: "ФАКУЛЬТЕТ ПЕДАГОГИКИ — ПЕДАГОГИКА",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Педагогика — профессия, которая формирует будущее</h2>
      <p>
        Педагогика — это больше, чем просто обучение. Это искусство и наука воспитания, развития и поддержки личности. Современный педагог —
        это наставник, методист, тьютор и лидер, способный вдохновлять и вести за собой.
      </p>
      <p>
        На факультете педагогики мы готовим специалистов, которые способны адаптироваться к вызовам времени и внедрять инновационные подходы
        в образование. Учебная программа сочетает теоретические знания с практическими навыками: от психологии детского возраста до цифровых
        образовательных технологий.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Возрастная и педагогическая психология</li>
        <li>Современные образовательные технологии</li>
        <li>Дизайн учебных программ</li>
        <li>Методика преподавания по различным дисциплинам</li>
        <li>Управление образовательным процессом</li>
        <li>Этические и правовые основы педагогики</li>
        <li>Работа с родителями и вовлечение сообщества</li>
        <li>Инклюзивное образование и работа с детьми с особыми потребностями</li>
      </ul>
      <p>
        Студенты получают доступ к стажировкам в школах, детских садах, образовательных центрах и НКО, что позволяет на практике применять
        полученные знания.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Преподаватель в школе, колледже или вузе</li>
        <li>Методист в образовательной организации</li>
        <li>Тьютор в онлайн- или офлайн-образовании</li>
        <li>Образовательный координатор в международных проектах</li>
        <li>Консультант по вопросам педагогики и развития детей</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€38,000 до €70,000 в год,</strong> в зависимости от страны и уровня квалификации.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный в ЕС и за его пределами</li>
        <li>Возможность учиться очно или дистанционно</li>
        <li>Практическая направленность программы</li>
        <li>Преподавание на русском или английском языке</li>
        <li>Сопровождение от поступления до трудоустройства</li>
        <li>Доступ к международным образовательным проектам</li>
      </ul>
      <p>Педагогика — это выбор для тех, кто хочет менять мир через образование.</p>
      <p>
        Наши выпускники становятся не просто преподавателями, а лидерами в образовательной сфере, внедряющими передовые практики и делая
        обучение доступным и эффективным для каждого.
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам определиться с направлением, собрать документы и пройти весь процесс поступления.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Педагогика — профессия, которая формирует будущее
    Педагогика — это больше, чем просто обучение. Это искусство и наука воспитания, развития и поддержки личности. Современный педагог — это наставник, методист, тьютор и лидер, способный вдохновлять и вести за собой.
    На факультете педагогики мы готовим специалистов, которые способны адаптироваться к вызовам времени и внедрять инновационные подходы в образование. Учебная программа сочетает теоретические знания с практическими навыками: от психологии детского возраста до цифровых образовательных технологий.
    Что вы будете изучать?
    • Возрастная и педагогическая психология
    • Современные образовательные технологии
    • Дизайн учебных программ
    • Методика преподавания по различным дисциплинам
    • Управление образовательным процессом
    • Этические и правовые основы педагогики
    • Работа с родителями и вовлечение сообщества
    • Инклюзивное образование и работа с детьми с особыми потребностями
    Студенты получают доступ к стажировкам в школах, детских садах, образовательных центрах и НКО, что позволяет на практике применять полученные знания.
    Кем можно работать после окончания?
    • Преподаватель в школе, колледже или вузе
    • Методист в образовательной организации
    • Тьютор в онлайн- или офлайн-образовании
    • Образовательный координатор в международных проектах
    • Консультант по вопросам педагогики и развития детей
    Зарплата в Европе: от €38,000 до €70,000 в год, в зависимости от страны и уровня квалификации.
    Почему выбирают нас?
    • Европейский диплом, признанный в ЕС и за его пределами
    • Возможность учиться очно или дистанционно
    • Практическая направленность программы
    • Преподавание на русском или английском языке
    • Сопровождение от поступления до трудоустройства
    • Доступ к международным образовательным проектам
    Педагогика — это выбор для тех, кто хочет менять мир через образование.
    Наши выпускники становятся не просто преподавателями, а лидерами в образовательной сфере, внедряющими передовые практики и делая обучение доступным и эффективным для каждого.
    Как поступить?
    Приёмная комиссия поможет вам определиться с направлением, собрать документы и пройти весь процесс поступления.
  `,
};
